import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageMeta from '@/components/app/pageMeta/PageMeta';
import { URLS } from '@/constants/global';
import { sendDatalayer, TITLE_DATALAYER } from '@/utils/gtm';
import { DefaultLayout } from '@/utils/layout';
import { TypePageHeader } from '@/utils/page';
import { TypeColor, TypeHeaderImgDisplay } from '@/utils/prismic';
import MainHeader from '@/components/common/mainHeader/MainHeader';
import Error from '@/components/app/error/Error';

const ExpiredListingPage = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const header: TypePageHeader = {
    hasSearchField: false,
    visualDisplayMode: TypeHeaderImgDisplay.FULL,
    bgColor: TypeColor.GREEN,
    cta: [],
    pressEnabled: false,
    title: t('expiredListing'),
    subTitle: t('expiredListingExplanation')
  };

  useEffect(() => {
    sendDatalayer({
      path: router && router.asPath,
      title: TITLE_DATALAYER.LISTING_EXPIRED
    });

    const timer = setTimeout(() => {
      router.push(URLS.SEARCH.href);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <PageMeta title={t('expiredListing')} isNotIndexable={true}>
      <DefaultLayout isTransparent>
        <MainHeader headerData={header} showBreadcrumb={false} />
        <Error message={t('expiredListingRedirect')} />
      </DefaultLayout>
    </PageMeta>
  );
};

export default ExpiredListingPage;
